<template>
  <div class="tasks-list">
    <div class="tasks-list-admin-header" v-if="isDesktop && isAdmin && currentCompany">
      <router-link :to="{ name: 'edit-company', params: { id: company } }">
        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-left" class="svg-inline--fa fa-arrow-left fa-w-14"
             role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
          <path fill="currentColor" d="M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4
              44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24
              24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"></path>
        </svg>
        Back to "{{ currentCompany.label }}"
      </router-link>
      <div class="form-element tasks-list-admin-header-companies">
        <label for="companiesList">Change company</label>
        <v-select class="form-control form-control__select tasks-list-header-boards-selector"
                  @change="changeCompany($event)"
                  :options="companies"
                  :searchable="true"
                  :clearable="false"
                  :value="this.currentCompany"
                  name="companiesList"
                  id="companiesList"/>
      </div>
    </div>
    <div id="taskHeader" class="task-header tasks-list-header"
         v-bind:class="{ 'search-opened': activeSearch, 'filters-opened': activeFilters }"
         v-if="!isDesktop">
      <div class="tasks-list-header-buttons">
        <div>
          <router-link :to="{ name: 'edit-company', params: { id: company } }" v-if="isAdmin">
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-left" class="svg-inline--fa fa-arrow-left fa-w-14"
                 role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
              <path fill="currentColor" d="M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4
              44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24
              24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"></path>
            </svg>
          </router-link>
          <router-link :to="{ name: userDashboard }" v-else>
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-left" class="svg-inline--fa fa-arrow-left fa-w-14"
                 role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
              <path fill="currentColor" d="M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4
              44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24
              24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"></path>
            </svg>
          </router-link>
          <app-select class="tasks-list-header-boards-selector"
                      @change="changeTaskBoard($event)"
                      :options="taskBoardList"
                      :searchable="false"
                      :customActive="false"
                      :clearable="false"
                      :value="this.activeTab"
                      data-vv-name="Task boards"
                      data-lpignore="true"
                      name="taskBoards"
                      id="taskBoards" />
        </div>
        <div>
          <button class="tasks-list-header-buttons-search-button"
                  v-bind:class="{ active: activeSearch }"
                  @click="activateSearch()">
            <template v-if="activeSearch">
              <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="times" class="svg-inline--fa fa-times fa-w-11"
                   role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512">
                <path fill="currentColor" d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48
                    0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28
                    12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48
                    0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path>
              </svg>
            </template>
            <template v-else>
              <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="search"
                   class="svg-inline--fa fa-search fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path fill="currentColor" d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9
                    0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4
                    33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2
                    128 128 0 70.7-57.2 128-128 128z"></path>
              </svg>
            </template>
          </button>
          <button class="tasks-list-header-buttons-filters-button"
                  v-bind:class="{ active: activeFilters }"
                  @click="activateFilters()">
            <template v-if="activeFilters">
              <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="times" class="svg-inline--fa fa-times fa-w-11"
                   role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512">
                <path fill="currentColor" d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48
                    0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28
                    12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48
                    0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path>
              </svg>
            </template>
            <template v-else>
              <span class="tasks-list-header-buttons-filters-button-count"
                  v-if="allActiveFiltersCount">{{ allActiveFiltersCount }}</span>
              <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="filter"
                   class="svg-inline--fa fa-filter fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path fill="currentColor" d="M487.976 0H24.028C2.71 0-8.047 25.866 7.058 40.971L192 225.941V432c0 7.831 3.821 15.17
                    10.237 19.662l80 55.98C298.02 518.69 320 507.493 320 487.98V225.941l184.947-184.97C520.021 25.896 509.338 0 487.976 0z"></path>
              </svg>
            </template>
          </button>
        </div>
      </div>
      <div class="tasks-list-header-container" v-if="activeSearch || activeFilters">
        <tasks-device-filters :company="company"
                              :only-search="activeSearch"
                              :list="activeTab.value"></tasks-device-filters>
      </div>
    </div>
    <tabs>
      <tab name="Current focus" alias="focus">
        <tasks-filters :company="company" list="focus" v-if="isDesktop"></tasks-filters>
        <focus-tasks :company="company"></focus-tasks>
      </tab>
      <tab name="Backlog" alias="backlog" :selected="true">
        <tasks-filters :company="company" list="backlog" v-if="isDesktop"></tasks-filters>
        <backlog-tasks :company="company"></backlog-tasks>
      </tab>
    </tabs>
  </div>
</template>

<script>
  import api from '@/api'
  import FocusTasks from './includes/FocusTasks'
  import BacklogTasks from './includes/BacklogTasks'
  import TasksFilters from './includes/TasksFilters'
  import AppSelect from '@/components/admin/common/Select'
  import { mapActions, mapGetters } from 'vuex'
  import TasksDeviceFilters from './includes/TasksDeviceFilters'

  export default {
    name: 'tasks-list',
    props: {
      company: {
        type: Number,
        required: true
      }
    },
    data () {
      return {
        searchKey: null,
        activeTab: null,
        activeSearch: false,
        activeFilters: false,
        companies: [],
        windowWidth: window.innerWidth
      }
    },
    computed: {
      ...mapGetters([
        'isAdmin',
        'isRegularUser'
      ]),
      taskBoardList () {
        return [
          {
            label: 'Current focus',
            value: 'focus'
          },
          {
            label: 'Backlog',
            value: 'backlog'
          }
        ]
      },
      isDesktop () {
        return this.windowWidth > 1090
      },
      allActiveFiltersCount () {
        let filtersCounter = 0
        if (!this.activeTab) {
          return filtersCounter
        }
        if (this.activeTab.value === 'backlog') {
          if (this.$route.query.bc && decodeURIComponent(this.$route.query.bc) !== '') {
            filtersCounter += decodeURIComponent(this.$route.query.bc).split(',').length
          }
          if (this.$route.query.ba && decodeURIComponent(this.$route.query.ba) !== '') {
            filtersCounter += decodeURIComponent(this.$route.query.ba).split(',').length
          }
          if (this.$route.query.status && decodeURIComponent(this.$route.query.status) !== '') {
            filtersCounter += decodeURIComponent(this.$route.query.status).split(',').length
          }
        } else {
          if (this.$route.query.fc && decodeURIComponent(this.$route.query.fc) !== '') {
            filtersCounter += decodeURIComponent(this.$route.query.fc).split(',').length
          }
          if (this.$route.query.fa && decodeURIComponent(this.$route.query.fa) !== '') {
            filtersCounter += decodeURIComponent(this.$route.query.fa).split(',').length
          }
        }
        if (this.$route.query.mandatory && decodeURIComponent(this.$route.query.mandatory) !== '') {
          filtersCounter += decodeURIComponent(this.$route.query.mandatory).split(',').length
        }
        return filtersCounter
      },
      currentCompany () {
        return this.companies.find((item) => item.value === this.company)
      },
      userDashboard () {
        if (this.isAdmin) {
          return 'admin'
        } else if (this.isRegularUser) {
          return 'user-app'
        } else {
          return 'knowledge-base'
        }
      }
    },
    methods: {
      ...mapActions([
        'getTaskChapters',
        'getTaskStatuses',
        'getTaskMandatory',
        'getTaskAssignee'
      ]),
      changeTaskBoard (event) {
        this.$router.replace({
          hash: event.value,
          query: {
            ...this.$route.query
          }
        })
      },
      setupInnerWidth () {
        this.windowWidth = window.innerWidth
      },
      activateSearch () {
        this.activeFilters = false
        this.activeSearch = !this.activeSearch
        this.maybeBodyScrollDisableNeeded()
      },
      activateFilters () {
        this.activeSearch = false
        this.activeFilters = !this.activeFilters
        this.maybeBodyScrollDisableNeeded()
        if (this.activeFilters) {
          window.scrollTo(0, 0)
        }
      },
      maybeBodyScrollDisableNeeded () {
        if (this.activeSearch) {
          document.body.style.overflow = 'hidden'
        } else {
          document.body.style.overflow = ''
        }
      },
      setupTasksMinHeight () {
        const tasks = document.querySelector('.wrap-task')
        const footer = document.querySelector('.front-footer')
        if (tasks && footer) {
          tasks.style.minHeight = (window.innerHeight - footer.offsetHeight) + 'px'
        }
      },
      getAllCompaniesForSelect () {
        this.$http.get(`${api.URLS.companiesS}/all/select`, api.headersAuthSettings)
          .then((res) => {
            this.companies = res.body
          }).catch(() => {})
      },
      changeCompany (event) {
        if (event.value === this.company) {
          return
        }
        let props = this.$router.resolve({
          name: 'company-tasks',
          hash: this.activeTab ? `#${this.activeTab.value}` : undefined,
          params: {
            companyId: event.value
          }
        })
        this.$router.push(props.href)
      }
    },
    components: {
      TasksDeviceFilters,
      TasksFilters,
      BacklogTasks,
      FocusTasks,
      AppSelect
    },
    beforeMount () {
      this.getTaskChapters(this.company)
      this.getTaskStatuses(this.company)
      this.getTaskAssignee(this.company)
    },
    created () {
      this.setupInnerWidth()
      this.setupTasksMinHeight()
      if (this.isAdmin) {
        this.getAllCompaniesForSelect()
      }
    },
    mounted () {
      if (this.$route.hash) {
        this.activeTab = this.taskBoardList.find((item) => item.value === this.$route.hash.replace('#', ''))
        this.getTaskMandatory({
          company: this.company,
          board: this.activeTab && this.activeTab.value === 'focus' ? 'current-focus' : null
        })
      } else {
        this.activeTab = this.taskBoardList[1]
        this.getTaskMandatory({
          company: this.company,
          board: null
        })
      }
      window.addEventListener('resize', this.setupInnerWidth)
      window.addEventListener('resize', this.setupTasksMinHeight)
    },
    destroyed () {
      window.removeEventListener('resize', this.setupInnerWidth)
      window.removeEventListener('resize', this.setupTasksMinHeight)
    },
    watch: {
      '$route' (to, from) {
        if (to.hash !== from.hash) {
          this.activeTab = this.taskBoardList.find((item) => item.value === this.$route.hash.replace('#', '')) || this.taskBoardList[1]
          this.getTaskMandatory({
            company: this.company,
            board: this.activeTab && this.activeTab.value === 'focus' ? 'current-focus' : null
          })
        }
      },
      company (value) {
        if (value) {
          this.getTaskChapters(this.company)
          this.getTaskStatuses(this.company)
          this.getTaskMandatory({
            company: this.company,
            board: this.activeTab && this.activeTab.value === 'focus' ? 'current-focus' : null
          })
          this.getTaskAssignee(this.company)
        }
      }
    }
  }
</script>

<style src="@/assets/scss/components/tasks/tasks.scss" lang="scss" scoped />



// WEBPACK FOOTER //
// TasksList.vue?300aeeb7